// import { EventMessage } from '@rta/rta-blueprint-library';
import { ReactElement, useEffect, useRef, useState } from 'react';

import { Appliance3dController } from './controller';
import { Render3DAppliance } from './core/components';
// WHAT WE HAD BEFORE:
// const RTABlueprint3D = require('./library/3dbundle');

// NEVER USED:
// import { RTABlueprint3D } from './library/3dbundle';

export type Appliance3dProps = {
	backgroundColor?: string;
	controller: Appliance3dController;
};

export const Appliance3d = (props: Appliance3dProps): ReactElement => {
	const {
		backgroundColor = 'white',
		controller = null
	} = props;
	// "Get the kitchen property from the props object. If kitchen doesn't exist on props, set it to null."

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [_forceRender, setForceRender] = useState<number>(0);
	// const [controllerSubscriptions, setControllerSubscriptions] = useState<string[]>([]);
	// const [event, setEvent] = useState<EventMessage>(null);

	const [containerSize, setContainerSize] = useState<{ width: number; height: number; }>(null);
	const containerRef = useRef<HTMLDivElement>(null);

	const { component = null } = controller;

	useEffect(() => {
		if (containerRef.current) {
			setContainerSize({
				width: containerRef.current.clientWidth,
				height: containerRef.current.clientHeight
			});
		}
	}, [containerRef]);

	useEffect(() => {
		if (containerRef.current) {
			setContainerSize({
				width: containerRef.current.clientWidth,
				height: containerRef.current.clientHeight
			});
		}
	}, [containerRef.current?.clientWidth, containerRef.current?.clientHeight]);

	// useEffect(() => {
	// 	if (controller) {
	// 		const subs = controllerSubscriptions;
	// 		subs.push(controller.subscribe('*', '*', setEvent));
	// 		subs.push(controller?.component.subscribe('*', '*', setEvent));
	// 		setControllerSubscriptions(subs);
	// 	}

	// 	return () => {
	// 		if (controller) {
	// 			controllerSubscriptions.forEach((sId) => { controller.unsubscribe(sId); });
	// 		}
	// 	}
	// }, [controller]);

	useEffect(() => {
		controller?.rebuild();
		// if (component) {
		// 	const subs = controllerSubscriptions;
		// 	subs.push(component.subscribe('*', ['created', 'updated', 'deleted'], setEvent));
		// 	setControllerSubscriptions(subs);
		// }

		// return () => {
		// 	if (controller) {
		// 		controllerSubscriptions.forEach((sId) => { controller.unsubscribe(sId); });
		// 	}
		// }
	}, [component]);

	// useEffect(() => {
	// 	if (event) controller.rebuild();
	// }, [event]);

	if (controller === null || component === null) return <></>;

	return <div ref={containerRef} style={{ position: 'relative', height: '100%', width: '100%' }}>
		{/* Perferred using the passed instance */}
		{ component && containerSize && <Render3DAppliance
			component={component}
			controller={controller}
			containerSize={containerSize}
			backgroundColor={backgroundColor}
		/> }
	</div>;
};
